// extracted by mini-css-extract-plugin
export default {"gridContainer":"PresupuestoGrid_gridContainer__AHV6c","cornerHeaderCell":"PresupuestoGrid_cornerHeaderCell__aoYMa"};